import React, { useState, useEffect, useRef, useCallback } from "react";

import Grid from "@mui/material/Grid2";
import { 
  Campaign, 
  Encounter,
} from "@dndModels";
import API from "@utilities/smart_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharConnectUtilities from "@dndUtilities/char_connect_utilities";
import LoadingBox from "@components/input/LoadingBox";
import ListOptionsInput from "@components/Navigation/ListOptionsInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import EncounterParent from "@dndComponents/campaign/encounters/EncounterParent";
import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import CommonUtilities from "@utilities/common_utilities";
import FlexBox from "@components/layout/FlexBox";

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  campaign: Campaign;
}

export default function QuickRulesControl({ campaign }: Props) {
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selected, setSelected] = useState<Encounter | undefined>(undefined);
  const [change_time, setChangeTime] = useState(0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer 
        open={!!selected} 
        onClose={() => { setSelected(undefined); }}
        full_page>
        <EncounterParent
          id={ selected ? selected._id : "" }
          encounter={selected}
        />
      </ModalOrDrawer>
    )
  }

  return (
    <FlexBox>
      Coming Soon. This is going to be a place where GMs can quickly look up rules, both general and specific. 
      It will have sections for different types of rules, a search tool which will search everything, 
      and will have each part put things that chars are using at the top, with the char names.
    </FlexBox>
  );
}
